export class TextareaHarnessController {
  public model1: string;
  public model2: string;
  public changeCount = 0;

  public increamentChangeCount() {
    this.changeCount++;
  }
}
